import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject
} from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Robot } from 'src/app/models/robot';
import { SpinnerState } from 'src/app/shared/ui/spinner/redux/spinner.state';
import { LoadAllRobots, LoadOwnerRobots } from '../redux';
import { QaState } from '../redux/qa.state';
import { QaServiceService } from '../services/qa-service.service';
import { CleanTimeEstimatesSubComponent } from './clean-time-estimates-sub/clean-time-estimates-sub.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-clean-time-estimates',
  templateUrl: './clean-time-estimates.component.html',
  styleUrls: ['./clean-time-estimates.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class CleanTimeEstimatesComponent implements OnInit, OnDestroy {
  public robot$: Observable<any[]> = inject(Store).select(QaState.robots);
  public ownerRobot$: Observable<any[]> = inject(Store).select(QaState.ownerRobots);
  public loading$: Observable<boolean> = inject(Store).select(SpinnerState.isLoading);
  private unsubscribe: Subject<void> = new Subject();

  public myRobots: Robot[] = [];
  public commonRobots: Robot[] = [];
  public robotSelected = false;
  public selectedRobot: Robot;
  public submissionSent = false;
  public estimateJson = '';

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('viewContainerRef', { read: ViewContainerRef })
  public VCR: ViewContainerRef;
  public child_unique_key = 0;
  public componentsReferences = Array<ComponentRef<CleanTimeEstimatesSubComponent>>();
  public spin;

  constructor(private store: Store, private CFR: ComponentFactoryResolver, public service: QaServiceService) {
    if (this.store.selectSnapshot(QaState.robots).length < 1) {
      this.store.dispatch(new LoadAllRobots());
    }
    if (!this.store.selectSnapshot(QaState.ownerRobots)) {
      this.store.dispatch(new LoadOwnerRobots());
    }
  }

  public ngOnInit(): void {
    this.robot$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.commonRobots = data));
    this.ownerRobot$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.myRobots = data));
    this.loading$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.spin = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public groupByFn = (item: any) => {
    return this.myRobots?.some((s: any) => s.id === item.id) ? 'My Robots' : 'Common Robots';
  };

  public clear() {
    this.robotSelected = false;
    this.child_unique_key = 0;
    this.componentsReferences = [];
  }

  /******************************************************
   * Robot selection in HTML
   *****************************************************/

  public onRobotSelect(selectBot) {
    this.selectedRobot = selectBot;
    if (selectBot !== null) {
      this.robotSelected = true;
    } else {
      this.robotSelected = false;
    }
  }

  public showSubmit(): boolean {
    return true;
  }

  public onSubmit() {
    const cleaningEstimate = [];
    this.componentsReferences.forEach((data) => {
      const estimate = data.instance.estimate;
      estimate.robot_id = this.selectedRobot.id;
      cleaningEstimate.push(estimate);
    });

    this.service.submitCleaningEstimateAmplify(cleaningEstimate);

    if (this.service.sentEstimates !== null) {
      this.submissionSent = true;
      this.estimateJson = JSON.stringify(this.service.sentEstimates);
    } else {
      this.submissionSent = false;
    }
  }

  public createComponent(data?, index?) {
    const componentFactory = this.CFR.resolveComponentFactory(CleanTimeEstimatesSubComponent);

    const childComponentRef = this.VCR.createComponent(componentFactory);

    const childComponent = childComponentRef.instance;
    childComponent.unique_key = ++this.child_unique_key;
    childComponent.parentRef = this;

    // add reference for newly created component
    this.componentsReferences.push(childComponentRef);
  }

  //Method to delete specific component from container view
  public remove(key: number) {
    if (this.VCR.length < 1) {
      return;
    }

    const componentRef = this.componentsReferences.filter((x) => x.instance.unique_key === key)[0];

    const vcrIndex: number = this.VCR.indexOf(componentRef.hostView);

    // removing component from container
    this.VCR.remove(vcrIndex);

    // removing component from the list
    this.componentsReferences = this.componentsReferences.filter((x) => x.instance.unique_key !== key);
  }
}
